import React from 'react';
import { ApiButton, Button, Dialog, DialogContent, Typography, DialogActions } from 'web-library';
import DialogTitle from '@mui/material/DialogTitle';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { MutationStatus } from 'react-query';

export interface ChangeExamSeriesModalProps {
  modelOpen: boolean;
  status: MutationStatus;
  onClickWithdraw: () => void;
  selectedValue?: string;
  onClose: (value?: string) => void;
}

const useStyles = makeStyles()((theme) =>
({
  actionButton: {
    '& .MuiButton-label div': {
      maxWidth: 400,
    },
  },
}));

const WithdrawalModal = ({
  modelOpen,
  status,
  onClickWithdraw,
  selectedValue,
  onClose,
}: ChangeExamSeriesModalProps) => {
  const handleClose = () => {
    onClose();
  };

  const { classes } = useStyles();

  return (
    <Dialog onClose={handleClose} open={modelOpen} maxWidth="sm">
      <DialogTitle>Withdraw from Exam?</DialogTitle>
      <DialogContent>
        <Typography>
          You are about to drop all registered subjects. Would you like to proceed with exam
          withdrawal?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button id="button-cancel-withdraw" type="button" variant="text" size="small" color="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <ApiButton
          id="button-withdraw"
          className={classes.actionButton}
          color="secondary"
          status={status}
          // @ts-ignore
          onClick={() => onClickWithdraw()}
          size="small"
        >
          Withdraw from Exam
        </ApiButton>
      </DialogActions>
    </Dialog>
  );
};

export default WithdrawalModal;
